import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { headers_skip_token } from '../services/utility.service';

export class TranslateHttpLoaderCustom implements TranslateLoader {
	constructor(
		private http: HttpClient,
		public prefix: string = '/assets/i18n/',
		public suffix: string = '.json'
	) { }

	/**
	 * Gets the translations from the server
	 */
	public getTranslation(lang: string): Observable<Object> {
		return this.http.get(`${this.prefix}${lang}${this.suffix}`, {
			headers: headers_skip_token
		});
	}
}
